import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Dropdown, DropdownButton } from 'react-bootstrap';
import { FaPlus, FaFileExport } from 'react-icons/fa';
import ApplicationTable from '../components/application/ApplicationTable';
import { getApplication, getExport } from '../api/services/ApplicationService';

const Application = () => {
    const navigate = useNavigate();
    const [applications, setApplications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [exportLoading, setExportLoading] = useState(false);

    const fetchApplications = async () => {
        try {
            setLoading(true);
            const response = await getApplication();
            setApplications(response);
            setError(null);
        } catch (error) {
            console.error('Error fetching applications:', error);
            setError('Failed to load applications');
            setApplications([]);
        } finally {
            setLoading(false);
        }
    };

    const handleExport = async (filter) => {
        try {
            setExportLoading(true);
            await getExport(filter); // pass the selected filter here
        } catch (error) {
            console.error('Export failed:', error);
            setError('Failed to export applications');
        } finally {
            setExportLoading(false);
        }
    };

    const handleStatusUpdate = (applicationId, newStatus) => {
        setApplications(prevApps =>
            prevApps.map(app =>
                app._id === applicationId ? { ...app, status: newStatus } : app
            )
        );
    };

    useEffect(() => {
        fetchApplications();
    }, []);

    if (loading) return (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: '50vh' }}>
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3">Loading applications...</p>
        </div>
    );

    if (error) return (
        <div className="alert alert-danger mx-3 mt-3">
            {error}
            <Button variant="link" onClick={fetchApplications}>Retry</Button>
        </div>
    );

    return (
        <div>
            <header className="content-header d-flex justify-content-between align-items-center mb-2">
                <h1 className="mb-0">Applications</h1>
                <div className="d-flex gap-2">
                    <DropdownButton
                        id="export-dropdown"
                        title={
                            exportLoading ? 'Exporting...' : <><FaFileExport className="me-2" /> Export</>
                        }
                        disabled={exportLoading || applications.length === 0}
                        variant="outline-primary"
                    >
                        <Dropdown.Item onClick={() => handleExport('all')}>All</Dropdown.Item>
                        <Dropdown.Item onClick={() => handleExport('active')}>Payment Success</Dropdown.Item>
                        <Dropdown.Item onClick={() => handleExport('inactive')}>Payment Failed</Dropdown.Item>
                    </DropdownButton>
                </div>
            </header>

            <ApplicationTable
                data={applications}
                onStatusUpdate={handleStatusUpdate}
                refreshData={fetchApplications} 
            />
        </div>
    );
};

export default Application;